import { useWhoAmI } from '@app/WhoAmI';
import { TreeNode } from '@components/TreePicker';
import { useWhoAmIv2Query } from '@generated/queries/whoAmIV2';
import { useEmployeeV2Flag } from '@hooks/useEmployeeV2Flag';
import { ReactElement, useContext, useEffect, useState } from 'react';
import {
  EmployeeTreeNodeValue,
  GroupTreeNodeValue,
  SidebarContext,
} from '../util';
import { GroupTreePicker } from './groupTreePicker';

interface Props {
  updateEmployeeTreeNodeValue: (emp: EmployeeTreeNodeValue) => void;
}
export const GroupTree = ({
  updateEmployeeTreeNodeValue,
}: Props): ReactElement => {
  const [noGroups, setNoGroups] = useState(true);
  const useEmployeeV2 = useEmployeeV2Flag();
  const { employee: loggedInUser } = useWhoAmI();
  const { data: loggedInUserV2 } = useWhoAmIv2Query();
  const [currentEmployee] = useState(
    useEmployeeV2 ? loggedInUserV2?.whoAmIV2?.employee : loggedInUser
  );
  const [groupTreeNodes, setGroupTreeNodes] = useState<
    TreeNode<GroupTreeNodeValue>[]
  >([]);

  const { group } = useContext(SidebarContext);

  useEffect(() => {
    setNoGroups(true);
    if (group) {
      setGroupTreeNodes([getGroupTreeNodes(group.id, group.groupName)]);
    }
  }, [group]);

  useEffect(() => {
    if (groupTreeNodes.length) {
      setNoGroups(false);
    }
  }, [groupTreeNodes]);

  const getGroupTreeNodes = (
    groupId: string,
    groupName: string
  ): TreeNode<GroupTreeNodeValue> => {
    return {
      id: groupId || '',
      label: groupName,
      value: {
        id: groupId || '',
        groupName: groupName || '',
      },
      isChecked: false,
      isExpanded: false,
      children: undefined,
    };
  };

  return (
    <div style={{ width: '98%' }}>
      {noGroups ? (
        <div>No Group found</div>
      ) : (
        <GroupTreePicker
          currentEmployee={currentEmployee}
          groupTreeNodes={groupTreeNodes}
          updateEmployeeTreeNodeValue={updateEmployeeTreeNodeValue}
          group={group}
        />
      )}
    </div>
  );
};
